import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, AsyncStorage, WebView, TouchableWithoutFeedback,
	Dimensions, Image, ImageBackground, SectionList, I18nManager as RNI18nManager, Platform } from "react-native";

import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons, Octicons, Feather } from "@expo/vector-icons";
import { format, parse, isThisHour } from 'date-fns'

import PlaceholderComp from "../utilities/PlaceholderComp";
import * as firebase from "firebase";
import TopBar from "../widgets/TopBar";
import Main from "../widgets/Main";
import Menu from "../widgets/Menu";
import HoverableOpacity from "../widgets/HoverableOpacity";
import { FlatList } from "react-native-gesture-handler";
import {StoryWrapper} from '../widgets/story.styled';
import i18n from 'i18n-js';
import MainComponent from "../utilities/MainComponent";
import moment from 'moment';
import AppContext, {AppProvider} from "../utilities/AppContext"
import { da } from "date-fns/locale";
import {
	responsiveScreenHeight,
	responsiveScreenWidth,
	responsiveScreenFontSize
  } from "react-native-responsive-dimensions";

export default class MenuScreen extends MainComponent {	
	
	static path = '';

	state = {
		showPromoError : false,
		applyPromo: false,
		store: {},
		title: "Menu",
		scrollOffset: 0,
		selectedIds : [],
		showCart: false,
		orderCount : 0,
		stories: [],
		totalPrice : 0,		
		deliveryData : {area: "", timings : ""},
		offerData : undefined,
		showBack 		: false,
		showMenu 		: false,
		showFullMode 	: true,
		data : [],
		mainData : [],
		fakeData : new Array(7).fill({})
	};
	
	static navigationOptions = {
		headerShown: false
	};

	changeState(states){
		if(states.openOrder != undefined && states.openOrder == true)
			this.reviewOrder()
		else
			this.setState(states)
	}

	constructor(props) {
		super(props);
		
		this.handleScroll = this.handleScroll.bind(this)
		this.changeState = this.changeState.bind(this)

		moment.locale('en');
		this.updateEndStatistics()
	}

	updateEndStatistics()
    {
        var mUpdates = {
            views    : firebase.database.ServerValue.increment(1)
        }

        // For admin statistics
        firebase.database().ref('statistics/admin/daily/shift_'   + moment(new Date()).format('DDMMYYYY') + "/shift_" + moment(new Date()).format('HH')).update(mUpdates)
        firebase.database().ref('statistics/admin/monthly/shift_' + moment(new Date()).format('MMYYYY')).update(mUpdates)
        firebase.database().ref('statistics/admin/yearly/shift_'  + moment(new Date()).format('YYYY')).update(mUpdates)
        firebase.database().ref('statistics/admin/overall/').update(mUpdates)
        
        firebase.database().ref('statistics/admin/topStores/daily/shift_'   + moment(new Date()).format('DDMMYYYY') + "/shift_" + moment(new Date()).format('HH') + "/" + store.storeId).update(mUpdates)
        firebase.database().ref('statistics/admin/topStores/monthly/shift_' + moment(new Date()).format('MMYYYY') + "/" + store.storeId).update(mUpdates)
        firebase.database().ref('statistics/admin/topStores/yearly/shift_'  + moment(new Date()).format('YYYY')   + "/" + store.storeId).update(mUpdates)

        // For store statistics
        firebase.database().ref('statistics/stores/daily/'   + store.storeId + '/shift_' + moment(new Date()).format('DDMMYYYY') + "/shift_" + moment(new Date()).format('HH')).update(mUpdates)
        firebase.database().ref('statistics/stores/monthly/' + store.storeId + '/shift_' + moment(new Date()).format('MMYYYY')).update(mUpdates)
        firebase.database().ref('statistics/stores/yearly/'  + store.storeId + '/shift_' + moment(new Date()).format('YYYY')).update(mUpdates)
        firebase.database().ref('statistics/stores/overall/' + store.storeId).update(mUpdates)
    }
	// ssh flexpape_gmail_com@34.87.16.1
	componentDidMount() {	

		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;

		this.state.height = screenHeight
		this.state.width  = screenWidth
				
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}

		if (Platform.OS === 'ios')
			this.state.showFullMode = false;

		setTimeout(() => {
			this.setState({timePassed: true})
		}, 5000)

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.getDetails()
	}

	getDetails = async () => {		
		
		await Font.loadAsync(color.appFonts);

		/*
		AsyncStorage.removeItem(store.promo).then((value) => {
		});*/

		let that = this
		this.state.mainData = []
		var index = 0
		firebase.database().ref('data/' + store.storeId + "/").once("value", function(snapshot) {

			var mMainList = []	
			var modifierMap = {}			
			snapshot.forEach(function(childSnapshot) {								
				
				var childData = childSnapshot.val();
				if(childData.status == true)
				{
					var itemsList = childData.items
					var data = []
					if (itemsList != undefined)
					{
						Object.keys(itemsList).forEach(key => {
							let value = itemsList[key];
							if(value.status == true)
							{
								let mItem = {isSelected: false, data: value}
								data.push(mItem)									
								
								if(value.addons != undefined)
								{
									let addons = value.addons
									Object.keys(addons).forEach(key => {
										let addon = addons[key];
										if(addon.modifiers == undefined)
											addon.modifiers = []
							
										if(addon.modifiers != undefined && addon.modifiers.length > 0 && addon.status)
										{
											addon.modifiers.forEach(modifier => {
												if(modifier.stock != undefined){
													modifierMap[modifier.key] = modifier
												}

												if(modifier.modifierTags != undefined )
												{
													modifier.modifierTags.forEach(modifierTag => 
													{
														if(modifierTag.modifiers != undefined)
														{
															modifierTag.modifiers.forEach(tagModifier => {
																if(tagModifier.stock != undefined){
																	modifierMap[tagModifier.key] = tagModifier
																}				
															})
														}
													})
												}

											})
										}
									});	
								}
							}
						});
						
						data.sort((a,b) => a.data.index - b.data.index);
						if(data.length > 0)
							data[data.length - 1].isLast = true
					}
					if(data.length > 0)
					{
						let category = {index: index, isExpanded: true, category: childData, data: data, dataCount: data.length}
						mMainList.push(category)
						index += 1
					}
				}
			});

			mMainList.sort((a,b) => a.category.index - b.category.index);
			that.setState({data: JSON.parse(JSON.stringify(mMainList)), mainData: mMainList, modifierMap: modifierMap})

		}.bind(this), function(error) { 
			console.log(error)
		});

		firebase.database().ref('stories/' + store.storeId + "/").once("value", function(snapshot) {
			var mainList = []
			let mData = snapshot.val()
			if(mData != undefined || mData != null)
			{
				Object.keys(mData).forEach(key => {
					let obj = mData[key];
					if(obj.status){
						mainList.push(obj)
					}												
				});

				that.state.stories = mainList
				that.setState({stories: mainList})
			}
		});

		firebase.database().ref('promotions/' + store.storeId).orderByChild("promotionType").startAt(1).once("value", function(snapshot) {
			snapshot.forEach(function(childSnapshot) 
			{						
				let mData = snapshot.val()
				if (mData != undefined){				
					let promoData = Object.keys(mData).map(function(key) {
						mData[key].key = key;
						return mData[key];
					})

					if(promoData.length > 0)
					{
						promoData.forEach(mPromotion => 
						{
							if(mPromotion.status == true)
							{
								if(mPromotion.promotionType == 1)
								{
									that.state.promoData = mPromotion	
								}
								else if(mPromotion.promotionType == 2)
								{
									that.state.offerData = mPromotion	
									var startDate = new Date().getTime()
									var endDate  = that.state.offerData.endDate
									var d = ((endDate - startDate)/1000).toFixed(0)
									d = Number(d);
									if(d > 10)
										that.setupTimer()
									else
										that.state.offerData = undefined
								}	
							}						
						})

						that.setState({promoData: that.state.promoData, offerData: that.state.offerData})												
					}
				}
			});

		}.bind(this), function(error) { 
			console.log(error)
		});

		this.updateCart()
	}

	setupTimer()
	{
		var that = this
		if(this.state.offerData != undefined)
		{
			const x = setInterval(()=>{
				if( this.state.offerData == undefined) {
				  clearInterval(x)
				}else {				 
					
					var startDate = new Date().getTime()
					var endDate  = this.state.offerData.endDate
					var d = ((endDate - startDate)/1000).toFixed(0)
					d = Number(d);
					if(d <= 0)
					{
						that.setState({offerData: undefined})		
						try{
							clearInterval(x)
						}catch(e){}
						return
					}	

					this.setState({
						offerData : this.state.offerData})
				}
			  },1000)
		}
	}

	updateCart = async () => {
		try {

			var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
			
			this.state.store = value

			if(this.state.store.orderLimit == undefined)
				this.state.store.orderLimit = 0
			if(this.state.store.todayOrdersCount == undefined)
				this.state.store.todayOrdersCount = 0

		} catch (error) {
			console.log(error)
		}

		// Set the key-value pairs for the different languages you want to support.
		var that = this
		firebase.database().ref('stores/' + store.storeId).once("value", function(snapshot) {			
			   
			let data = snapshot.val()
			if(data != undefined)
			{
				AsyncStorage.setItem(store.storeData, JSON.stringify(data)).then((value) => {});
				this.state.store = data
				if(this.state.store.orderLimit == undefined)
					this.state.store.orderLimit = 0
				if(this.state.store.todayOrdersCount == undefined)
					this.state.store.todayOrdersCount = 0
				if(this.state.store.todayOrdersCount >= this.state.store.orderLimit)
					this.state.store.state = false
					
				that.setState({store: this.state.store})		 
			}

		}.bind(this), function(error) { 
			console.log(error)
		});

		try{
			if(this.state.store.enableDelivery || this.state.store.enablePickup || this.state.store.enableCustomDelivery)
			{
				var value = await AsyncStorage.getItem(store.delivery)
				if (value == undefined || value == null || value == "null")
					value = {area: "", timings : ""}
				else
				{
					if(!this.state.store.enablePickup && JSON.parse(value).branch != undefined)
						value = {area: "", timings : ""}
					if(!this.state.store.enableDelivery && ! this.state.store.enableCustomDelivery && JSON.parse(value).area != undefined)
						value = {area: "", timings : ""}
						
					this.state.deliveryData = JSON.parse(value)
					this.context.setDeliveryData(JSON.parse(value))
				}
			}
			
		} catch (error) {
			//console.log(error)
		}

		try{			

			value = await AsyncStorage.getItem(store.key)
			if (value == undefined)
				value = []
			else
			{
				try{
					value = JSON.parse(value)
				} catch (error) {
					value = []
				}
			}			

			if(value.length > 0)
			{
				const {reset, ordersCount, mainTotalPrice, selectedIds,  ordersData} = this.calculateTotalOrderPrice(
						value, this.state.store, this.state.deliveryData, this.state.applyPromo == true ? this.state.promoData : undefined 
				)
				if(reset)
				{
					await AsyncStorage.removeItem(store.key)
					this.setState({isLoading: false})
				}
				else
					this.setState({showCart: true, totalPrice: mainTotalPrice, orderCount: ordersCount, selectedIds: selectedIds, orderData: ordersData})
			}
			else
				this.setState({showCart: false, isLoading: false, totalPrice: 0, orderCount: 0, selectedIds: [], orderData: []})

		} catch (error) {
			console.log(error)
			this.setState({showCart: false, isLoading: false, totalPrice: 0, orderCount: 0, selectedIds: [], orderData: []})
		}
	}

   listRowPressed(item){
		this.context.onUpdate = this.updateCart.bind(this)
		this.context.itemData = item.data

		this.props.navigation.navigate('details', {
			item: item.data.key
		});				
	}

	setCategory(mCat){

		let index = mCat.index	
		mCat.isExpanded = !mCat.isExpanded
		this.state.mainData[index].isExpanded = mCat.isExpanded;
		var categories = []		
		
		var mIndex = 0
		this.state.mainData.map(category => {											
			if(!category.isExpanded){
				let mCategory  = {index: mIndex, isExpanded: false, category: category.category, data: [], dataCount: category.dataCount}
				categories.push(mCategory)
			}else{
				let mCategory  = {index: mIndex, isExpanded: true, category: category.category, data: category.data, dataCount: category.dataCount}
				categories.push(mCategory)
			}

			mIndex += 1
		})

		this.setState({data: categories, mainData: this.state.mainData})
	}

	/**
	 * 
	 *	IBOutlets 
	 * 
	 */

	switchToSearch(){
		//alert(Platform.OS +  + this.state.width)
		this.props.navigation.navigate('search')
	}

	openArea(){
		this.context.onUpdate = this.onSelectArea.bind(this)
		this.props.navigation.navigate('area');		
	}

	onSelectArea = async data => {	
		this.setState({deliveryData: data});
		await AsyncStorage.setItem(store.delivery, JSON.stringify(data))
		const {ordersCount, mainTotalPrice, selectedIds,  ordersData} = this.calculateTotalOrderPrice(
			this.state.orderData, this.state.store, this.state.deliveryData, this.state.promoData)					
		this.setState({totalPrice: mainTotalPrice, orderCount: ordersCount, selectedIds: selectedIds, orderData: this.state.orderData})
	};

	openScheduleTimings(){
		this.context.onUpdate = this.onSelectTimings.bind(this)
		this.props.navigation.navigate('scheduled');
	}

	onSelectTimings = async data => {
		let deliveryData = {area: data.area, timings: data.timings}
		this.setState({deliveryData: deliveryData});
		await AsyncStorage.setItem(store.delivery, JSON.stringify(deliveryData))
	};

	changeToDelivery()
	{
		this.context.onUpdate = this.onSelectArea.bind(this)
		this.props.navigation.navigate('area');		
	}

	/**
	 * 
	 * 
	 */
	reviewOrder(){

		if(this.state.store.enableDelivery || this.state.store.enableCustomDelivery)
		{
			if(this.state.deliveryData.area != undefined)
			{
				if(this.state.deliveryData == undefined || this.state.deliveryData.area == undefined
					|| this.state.deliveryData.area === {} || this.state.deliveryData.area == ''){
					this.openArea()
					return
				}

				if(this.state.deliveryData == undefined || this.state.deliveryData.area == undefined
					|| this.state.deliveryData.timings === {} || this.state.deliveryData.timings == ''){
					this.openScheduleTimings();
					return
				}
			}
		}
			
		if(this.state.applyPromo == true && this.state.promoData != undefined)
		{
			this.context.onUpdate = this.updateCart.bind(this)
			AsyncStorage.setItem(store.promo, JSON.stringify(this.state.promoData)).then((value) => {
				this.props.navigation.navigate("review");
			});
		}
		else
		{
			AsyncStorage.removeItem(store.promo).then((value) => {
				this.context.onUpdate = this.updateCart.bind(this)
				this.props.navigation.navigate("review");
			});
		}
	}

	moveToOrder(){

		var minOrderValueRequired = this.state.store.minimumOrder
		if(this.state.deliveryData.area != undefined)
		{
			minOrderValueRequired = this.state.deliveryData.area.minOrderPrice
		}


		if(this.state.totalPrice < minOrderValueRequired)
			return;

		this.context.onUpdate = this.updateCart.bind(this)
		this.props.navigation.navigate("review");
	}

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */

	handleScroll(event){
		this.setState({
			scrollOffset: event.nativeEvent.contentOffset.y
		})
	}

	openStory(){

		this.context.storyData = {
			index: 0,
			stories: this.state.stories
		}
		this.props.navigation.navigate('story')
	}

	openBranch()
	{
		this.props.navigation.navigate("branches");
	}

	/**
	 * 
	 * 
	 */
	showCategoryData(data)
	{
		this.setState({categoryData: data})
	}

	/**
	 * 
	 * 
	 * 
	 * 
	 * 
	 * 
	 * 
	 */

	renderStoryItem = ({ item, index }) => {
		var that = this;
		return (
				<View style={{marginLeft: 10, flex:1, width: 110, height: 100}}>
				
					<HoverableOpacity style={
							{width: 100, height: 100, 
							justifyContent: "center", alignItems: "center", alignItems: "center", 
						}}
							onPress={() => 
							{
								that.context.storyData = {
									index: index,
									stories: that.state.stories
								}
								that.props.navigation.navigate('story') 							
						 	}}
						>
							<StoryWrapper>
								<img style={{width:70, height:70, borderRadius: "50%", overflow:"hidden"}} src={item.images[0]} />
								<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">  
									<circle cx="50" cy="50" r="40" />
								</svg>
							</StoryWrapper>							
					</HoverableOpacity>														
				</View>
		)
	}

	/**
	 * 
	 * 
	 * 
	 * 
	 */

	renderSectionHeader = ({ section }) => 
	{
		let scrollOffsetRequired = this.state.headerHeight

		var height = 55
		if(this.state.scrollOffset > scrollOffsetRequired && !this.state.showFullMode && section.index == 0){
			//height += 50
		}
		var name 	= section.category.name
        var details = section.category.details;

        if(i18n.locale != this.state.store.defaultLanguage){
            name    = section.category.nameSecondary
            details = section.category.detailsSecondary
        }

        if(name == undefined || name == "")
            name = section.category.name
        if(details == undefined || details == "")
            details = section.category.details

		return (
			<View  style={{height: height, backgroundColor: "white"}}>
				
				{ height > 55 && !this.state.showFullMode && (
					<View style={{height: 50}}/>
				)}

				<View  style={{ flexDirection: "row", height: 55, justifyContent: "center", alignContent: "center", alignItems:"center" }}>
						<View  style={{flex:1, marginLeft: 15, justifyContent: "center"}}>
							<Text style={{textAlign:'left', fontFamily: 'main-regular', color: "black"  , fontSize: 18 }}>{name}</Text>
							<Text style={{textAlign:'left', fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12 }}>{details}</Text>
						</View>
						{ !section.isExpanded && (<Text style={{ fontFamily: 'main-regular',marginLeft: "auto", marginRight: 10, fontWeight: "bold", color: color.detailsColor  , fontSize: 16 }}> {section.dataCount} </Text>)}	
						<TouchableOpacity style={{marginLeft: "auto", marginRight: 10}} 
									onPress={() => { this.setCategory(section) }}
						>
							{ section.isExpanded && (<Ionicons name="ios-arrow-down" size={24} color="black" />)}	
							{ !section.isExpanded && (<Ionicons name="ios-arrow-up" size={24} color="black" />)}	
						</TouchableOpacity>
				</View>
				<View style={{height: 1, backgroundColor:color.bigSeparator}}/>
			</View>
		  );
	}

	reduceCounter(item){
		var that = this
		var itemsList = []
		this.state.orderData.forEach(data => 
		{
			if(data.key == item.data.key)
				data.counter -= 1

			if(data.counter > 0)
				itemsList.push(data)			
		})

		console.log(itemsList)
		var value = JSON.stringify(itemsList)
		AsyncStorage.setItem(store.key, value).then((value) => 
		{
			that.updateCart()
		});
	}

	addCounter(item)
	{
		var shouldAllow = true
		var that = this
		var itemsList = []

		var tempData = [...this.state.orderData]
		this.state.orderData.forEach(data => 
		{
			if(data.key == item.data.key)
			{
				var allowStock =  item.data.allowStock == undefined ? false : item.data.allowStock
				if(allowStock)
				{
					let stock = item.data.stock == undefined ? 0 : item.data.stock
					if(data.counter >= stock){
						shouldAllow = false
					}else{
						data.counter += 1
					}
				}else
				{
					data.counter += 1
				}
			}

			if(data.counter > 0)
				itemsList.push(data)
		})


		if(shouldAllow)
		{
			var value = JSON.stringify(itemsList)
			this.state.orderData = JSON.parse(value)
			AsyncStorage.setItem(store.key, value).then((value) => 
			{
				that.updateCart()
			});
		}else{
			this.state.orderData = tempData
		}
	}

	addToCart(item)
	{
		var shouldAllow = true
		var stockCounter = 0

		var allowStock = item.data.allowStock == undefined ? false : item.data.allowStock
		if(allowStock)
		{
			let stockQty = item.data.stock == undefined ? 0 : item.data.stock
			if(stockQty <= 0){
				alert(i18n.t("outOfStock"))
				return
			}
		}

		var allowStock =  item.data.allowStock == undefined ? false : item.data.allowStock
		if (allowStock)
		{
			let stockQty = item.data.stock == undefined ? 0 : item.data.stock
			this.state.orderData.forEach(data => 
			{
				if(data.key == item.data.key)
				{
					stockCounter += data.counter
					if(data.counter > 0)
						itemsList.push(data)
				}
			})

			stockCounter += +this.state.counter
			if(stockCounter >= stockQty)
				shouldAllow = false
		}

		if(!shouldAllow){
			alert(i18n.t("outOfStock"))
			return
		}
		
		var that = this
		let mItem = {
			mainItem     : item.data,
			categoryId   : item.data.categoryId,
			counter 	 : 1,
			key 		 : item.data.key,
			productId	 : item.data.productId, 
			name		 : item.data.name, 
			price		 : item.data.price,
			images	 	 : item.data.images == undefined ? [] : item.data.images,
			details 	 : item.data.details,
			instructions : "",
			tax			 : item.data.tax,			
			disableTax   : item.data.disableTax == undefined ? false : item.data.disableTax,								
			addons : []
		}

		if(this.state.orderData == undefined)
			this.state.orderData = []

		this.callPixelEvent("Add To Cart", mItem)
		this.state.orderData.push(mItem)

		
		var value = JSON.stringify(this.state.orderData)
		AsyncStorage.setItem(store.key, value).then((value) => 
		{
			that.updateCart()
		});
	}

	renderGalleryCategory = ({item, index}) => {

		var name 	= item.category.name
        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.category.nameSecondary
        }

        if(name == undefined || name == "")
            name = item.category.name

		var marginLeft  = 10
		var marginRight = 10
		if(index%2 != 0)
			marginLeft = 5
		else
			marginRight = 5

		var width = (this.state.width * .33 - 30)/2
		if(!this.state.showFullMode)
			width = (this.state.width  - 30)/2

		return (
			<HoverableOpacity style={{marginTop: 10, height: width + 45, marginLeft: marginLeft, marginRight: marginRight, width: width}}
				onPress={() => this.showCategoryData(item) }
			>
				<View  style={{height: width + 25}}>					
					<ImageBackground 
						source={item.category.logoUrl}
						style={{height: width, width:width, overflow:"visible"}}
						imageStyle={{ borderRadius: 10}}
						/>
					<Text style={{marginTop: 5, textAlign:"left", fontFamily: "main-bold", color:'black', fontSize:14}}>{name}</Text>			
				</View>
			</HoverableOpacity>
		);
	}

	renderGalleryItem = ({item, index}) => {

		var name 	= item.data.name
        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.data.nameSec
		}
		
		var imageUrl = ""
		if(item.data.images != undefined && item.data.images.length > 0)
			imageUrl = item.data.images[0]
		else 
			imageUrl = require('../assets/placeholder.png')

        if(name == undefined || name == "")
            name = item.data.name

		var marginLeft  = 10
		var marginRight = 10
		if(index%2 != 0)
			marginLeft = 5
		else
			marginRight = 5

		var width = (this.state.width * .33 - 30)/2
		if(!this.state.showFullMode)
			width = (this.state.width  - 30)/2
			
		var price = +item.data.price
		price = price.toFixed(3)
		var priceText = price
		if(price == 0)
			priceText = "-"
		else
		{
			if(RNI18nManager.isRTL)
				priceText = price + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				priceText = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + price
		}

		var bannerImg = item.data.stockType == undefined ? "" : item.data.stockType
		if(bannerImg == "-")
			bannerImg = ""
			
		else if (bannerImg == "soldOut")
		{
			if(RNI18nManager.isRTL)
				bannerImg = require('../assets/sold_out_ar.png')
			else
				bannerImg = require('../assets/sold_out.png')
		}
		else if (bannerImg == "new")
		{
			if(RNI18nManager.isRTL)
				bannerImg = require('../assets/new_ar.png')
			else
				bannerImg = require('../assets/new.png')
		}
		else if (bannerImg == "offer")
		{
			if(RNI18nManager.isRTL)
				bannerImg = require('../assets/offer_ar.png')
			else
				bannerImg = require('../assets/offer.png')
		}

		var marginWidth = width - 90
		if(RNI18nManager.isRTL)
			marginWidth = 0

		var counter = this.state.selectedIds[item.data.key] 
		if(counter == undefined)
			counter = 0

		// Need to check if it is out of order or not
		var disabled = false
		var opacity = 1
		var allowStock = item.data.allowStock == undefined ? false : item.data.allowStock
		if(allowStock)
		{
			let stockQty = item.data.stock == undefined ? 0 : item.data.stock
			if(stockQty <= 0){
				disabled = true
				opacity = .5
			}
		}

		return (
			<View disabled={disabled} style={{marginTop: 5, height: width + 110, marginLeft: marginLeft, marginRight: marginRight, width: width}}
				onPress={() => this.listRowPressed(item) }
			>
				<View  style={{height: width + 110}}>	

					<HoverableOpacity style={{height: width, width:width}}
							onPress={() => this.listRowPressed(item) }
						>	
						<ImageBackground 
							source={imageUrl}
							style={{height: width, width:width, overflow:"visible"}}
							imageStyle={{ borderRadius: 10}}
							/>
					</HoverableOpacity>

					<Image source={bannerImg} style={{width: 90, height: 90, position: "absolute", marginLeft: marginWidth, overflow:"hidden"}}/>	
					<View style={{flexDirection: "row", marginTop: 5, alignItems: "center"}}>
						{ counter > 0 && !RNI18nManager.isRTL && (
							<Text style={{textAlign:"left", fontFamily: 'main-bold', color: this.state.store.primaryColor, fontSize: 16 }}>{counter}x </Text>
						)}
						{ counter > 0 && RNI18nManager.isRTL &&  (
							<Text style={{textAlign:"left", fontFamily: 'main-bold', color: this.state.store.primaryColor, fontSize: 16 }}> x{counter}</Text>
						)}	
						<Text numberOfLines={1} style={{textAlign:"left", fontFamily: "main-regular", color:'black', fontSize:14}}>{name}</Text>			
					</View>
					<Text style={{marginTop: 5, textAlign:"left", fontFamily: "main-regular", color:'black', fontSize:14}}>{priceText}</Text>			
					
					{ counter > 0 && (
						<View style={{flexDirection: "row", alignItems: "center", marginTop: 7.5}}>
								
								<HoverableOpacity style={{height:35, width: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
										onPress={() => { 
										this.reduceCounter(item) 
									}}
									>
									<Feather name="minus" size={24} color={this.state.store.primaryColor} />														
								</HoverableOpacity>									

								<HoverableOpacity style={{marginLeft: 15, height:35, width: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
										onPress={() => { 
										this.addCounter(item) 
									}}
									>
									<Feather name="plus" size={24} color={this.state.store.primaryColor} />														
								</HoverableOpacity>		

						</View>
					)}

					{ counter == 0 && item.data.addons != undefined && (
						<HoverableOpacity style={{marginTop: 10, opacity: opacity, width: width, height: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
							onPress={() => { 
								this.listRowPressed(item) 
							}}
						>
								<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 12, fontFamily: "main-regular", textAlign: "center"}}>{i18n.t("priceSelection")}</Text>														
						</HoverableOpacity>
					)}

					{ counter == 0 && (item.data.addons == undefined ||  item.data.addons.length == 0) && (
						<HoverableOpacity style={{marginTop: 10, opacity: opacity, width: width, height: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
							onPress={() => { 
								this.addToCart(item) 
							}}
						>
								<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 12, fontFamily: "main-regular", textAlign: "center"}}>{i18n.t("addToOrder")}</Text>														
						</HoverableOpacity>
					)}

				</View>
			</View>
		);
	}

	renderListCategory = ({item, index}) => {

		var name 	= item.category.name
        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.category.nameSecondary
        }

        if(name == undefined || name == "")
            name = item.category.name

		var marginLeft  = 10
		var marginRight = 10

		let height = 330
		var mainHeight = height
		if(index > 0)
			mainHeight = mainHeight + 15
		
		return (
			<View style={{height: mainHeight}}
				onPress={() => this.showCategoryData(item) }
			>
				{index > 0 && (
					<View style={{height: 15, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
				)}
				<View  style={{height: height, marginLeft: marginLeft, marginRight: marginRight}}>					
					<View  style={{ flexDirection: "row", height: 55, justifyContent: "center", alignContent: "center", alignItems:"center" }}>
							<View  style={{flex:1, marginLeft: 15, justifyContent: "center"}}>
								<Text style={{textAlign:'left', fontFamily: 'main-regular', color: "black"  , fontSize: 18 }}>{name}</Text>
							</View>
							<HoverableOpacity style={{marginLeft: "auto", marginRight: 10}}
									onPress={() => this.showCategoryData(item) }
								>
								<Text style={{ fontFamily: 'main-regular', fontWeight: "bold", color: color.detailsColor  , fontSize: 16 }}> {i18n.t("showMore")} </Text>
							</HoverableOpacity>
					</View>

					<FlatList
							showsHorizontalScrollIndicator={false}
							style={{height: 275}}
							data={item.data}
							horizontal={true}
							renderItem={this.renderHorizontalItem}
						/>

				</View>
			</View>
		);
	}

	renderListItem = ({ item, index }) => 
	{	
		var disabled = false
		var opacity = 1
		var allowStock = item.data.allowStock == undefined ? false : item.data.allowStock
		if(allowStock)
		{
			let stockQty = item.data.stock == undefined ? 0 : item.data.stock
			if(stockQty <= 0){
				disabled = true
				opacity = .5
			}
		}

		var height = 145
		if (item.isLast)
			height = height + 8

		var seprationColor = color.bigSeparator
		var counter = this.state.selectedIds[item.data.key] 
		if(counter != undefined)
			seprationColor = this.state.store.primaryColor	
		else
			counter = 0

		var textWidth = this.state.width - 15 - 15 - 90
		if(this.state.showFullMode)
			textWidth = this.state.width * .33 - 15 - 15 - 90
		
		var name 	= item.data.name
        var details = item.data.details;

        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.data.nameSec
            details = item.data.detailsSec
        }

        if(name == undefined || name == "")
            name = item.data.name
        if(details == undefined || details == "")
			details = item.data.details
		
		var price = +item.data.price
		price = price.toFixed(3)
		var priceText = price
		if(price == 0)
			priceText = i18n.t("priceSelection")
		else
		{
			if(RNI18nManager.isRTL)
				priceText = price + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				priceText = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + price
		}

		if(this.state.store.currency == undefined)
			this.state.store.currency = ""
		
		return (
				<HoverableOpacity  disabled={disabled} style={{height: height}}
					onPress={() => this.listRowPressed(item)}
				>
					<View  style={{height: height}}>
						
						<View style={{height: 1, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
						
						<View  style={{ flexDirection: "row", height: height - 9, justifyContent: "center", alignContent: "center", alignItems:"center"}}>
							   
								{ counter > 0 && (
								<View style={{width: 4, height: height - 1, backgroundColor: seprationColor, justifyContent: "center"}}/>
								)}
								<View style={{marginLeft: 15, height: '100%'}}>
									
									<View style={{flexDirection: "row", marginTop: 15}}>
										{ counter > 0 && !RNI18nManager.isRTL && (
											<Text style={{textAlign:"left", fontFamily: 'main-bold', color: this.state.store.primaryColor, fontSize: 16 }}>{counter}x </Text>
										)}
										{ counter > 0 && RNI18nManager.isRTL &&  (
											<Text style={{textAlign:"left", fontFamily: 'main-bold', color: this.state.store.primaryColor, fontSize: 16 }}> x{counter}</Text>
										)}	
										<Text numberOfLines={1} style={{textAlign:"left", fontFamily: "main-regular", color:'black', fontSize:14}}>{name}</Text>			
											
									</View>

									<Text numberOfLines={2} style={{marginTop: 5, width: textWidth - 8,}}>{details}</Text>
									
									<View style={{marginTop: "auto", height: 35, marginBottom: 15, alignItems: "center", alignContent: "center", flexDirection: "row"}}>
										<View style={{width: 120, height: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}>
											<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 11, textAlign: "center"}}>{priceText}</Text>
										</View>
										{ counter > 0 && (
											<TouchableWithoutFeedback style={{height:35}}
											onPress={() => { 
												this.reduceCounter(item) 
											}}
											>
												<Octicons style={{marginLeft: 15}} name="diff-removed" size={35} color={this.state.store.primaryColor} />														
											</TouchableWithoutFeedback>									
										)}
										{ counter > 0 && (
											<TouchableWithoutFeedback style={{height:35}}
												onPress={() => { 
													this.addCounter(item) 
												}}
											>
												<Octicons style={{marginLeft: 15}} name="diff-added" size={35} color={this.state.store.primaryColor} />														
											</TouchableWithoutFeedback>										
										)}

										{ counter == 0 && (item.data.addons == undefined || item.data.addons.length == 0) && (
											<TouchableWithoutFeedback style={{height:35}}
												onPress={() => { 
													this.addToCart(item) 
												}}
											>
												<Feather style={{marginLeft: 15}} name="shopping-bag" size={35} color={color.detailsColor} />														
											</TouchableWithoutFeedback>										
										)}
									</View>
							</View>
								{ item.data.images != undefined && item.data.images.length > 0 && (
									<Image source={item.data.images[0]} style={{width: 90, height: 90, borderRadius: 5, overflow:"hidden", marginLeft: "auto", marginRight: 15}}/>
								)}
						</View>

						{ item.isLast &&( <View style={{height: 8, backgroundColor: color.bigSeparator}}/> )} 

					</View>
				</HoverableOpacity>
		);
	}

	renderHorizontalItem = ({item, index}) => {

		var disabled = false
		var opacity = 1
		var allowStock = item.data.allowStock == undefined ? false : item.data.allowStock
		if(allowStock)
		{
			let stockQty = item.data.stock == undefined ? 0 : item.data.stock
			if(stockQty <= 0){
				disabled = true
				opacity = .5
			}
		}

		var name 	= item.data.name
        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.data.nameSec
		}

		var counter = this.state.selectedIds[item.data.key] 
		if(counter == undefined)
			counter = 0
		
		var imageUrl = ""
		if(item.data.images != undefined && item.data.images.length > 0)
			imageUrl = item.data.images[0]

        if(name == undefined || name == "")
            name = item.data.name

		var marginLeft  = 10
		var marginRight = 10
		if(index%2 != 0)
			marginLeft = 5
		else
			marginRight = 5

		var width = 135
		var height = 275

		var price = +item.data.price
		price = price.toFixed(3)
		var priceText = price
		if(price == 0)
			priceText = "-"
		else
		{
			if(RNI18nManager.isRTL)
				priceText = price + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				priceText = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + price
		}

		return (
			<View disabled={disabled} style={{height: height, marginLeft: marginLeft, marginRight: marginRight, width: width}}>
					
					<HoverableOpacity
							style={{height: 160, width: width, overflow:"visible"}}
							onPress={() => this.listRowPressed(item) }
					>
						<ImageBackground 
							source={imageUrl}
							style={{height: 160, width: width, overflow:"visible"}}
							imageStyle={{ borderRadius: 10}}
							/>
					</HoverableOpacity>

					<View style={{flexDirection: "row", marginTop: 5, alignItems: "center"}}>
						{ counter > 0 && !RNI18nManager.isRTL && (
							<Text style={{textAlign:"left", fontFamily: 'main-bold', color: this.state.store.primaryColor, fontSize: 16 }}>{counter}x </Text>
						)}
										{ counter > 0 && RNI18nManager.isRTL &&  (
											<Text style={{textAlign:"left", fontFamily: 'main-bold', color: this.state.store.primaryColor, fontSize: 16 }}> x{counter}</Text>
										)}	
						<Text numberOfLines={1} style={{textAlign:"left", fontFamily: "main-regular", color:'black', fontSize:14}}>{name}</Text>			
					</View>

					<Text style={{marginTop: 5, textAlign:"left", fontFamily: "main-regular", color:'black', fontSize:12}}>{priceText}</Text>	

					{ counter > 0 && (
						<View style={{flexDirection: "row", alignItems: "center", marginTop: 7.5, height: 35}}>
								
								<HoverableOpacity style={{height:35, width: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
										onPress={() => { 
										this.reduceCounter(item) 
									}}
									>
									<Feather name="minus" size={24} color={this.state.store.primaryColor} />														
								</HoverableOpacity>									

								<HoverableOpacity style={{marginLeft: 15, height:35, width: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
										onPress={() => { 
										this.addCounter(item) 
									}}
									>
									<Feather name="plus" size={24} color={this.state.store.primaryColor} />														
								</HoverableOpacity>		

						</View>
					)}

					{ counter == 0 && item.data.addons != undefined && (
						<HoverableOpacity style={{marginTop: 10, opacity: opacity, width: width, height: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
							onPress={() => { 
								this.listRowPressed(item) 
							}}
						>
								<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 12, fontFamily: "main-regular", textAlign: "center"}}>{i18n.t("priceSelection")}</Text>														
						</HoverableOpacity>
					)}

					{ counter == 0 && (item.data.addons == undefined ||  item.data.addons.length == 0) && (
						<HoverableOpacity style={{marginTop: 10, opacity: opacity, width: width, height: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
							onPress={() => { 
								this.addToCart(item) 
							}}
						>
								<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 12, fontFamily: "main-regular", textAlign: "center"}}>{i18n.t("addToOrder")}</Text>														
						</HoverableOpacity>
					)}

			</View>
		);
	}

	applyPromo()
	{
		if(this.state.promoData != undefined)
		{	
			if(this.state.orderData == undefined)
				this.state.orderData = []
			this.state.applyPromo = true
			const {ordersCount, mainTotalPrice, selectedIds,  ordersData} = this.calculateTotalOrderPrice(
					this.state.orderData, this.state.store, this.state.deliveryData, this.state.promoData)					
			this.setState({showPromoError: false, applyPromo: true, totalPrice: mainTotalPrice, orderCount: ordersCount, selectedIds: selectedIds, orderData: this.state.orderData})
		}
	}
	
	/**
	 * 
	 */
	

	renderHeader(that){
		//var that = this
		var timings = ""
		if(that.state.deliveryData != undefined && that.state.deliveryData.timings != undefined && that.state.deliveryData.timings != "")
		{
			try{
				timings = format(parse(that.state.deliveryData.timings.date, 'dd-MM-yyyy', new Date()), 'dd MMM') + " " +  that.state.deliveryData.timings.data.openingTime + " - " + that.state.deliveryData.timings.data.closingTime
			}catch{
				timings =  i18n.t(this.state.deliveryData.timings.date, {defaultValue: this.state.deliveryData.timings.date})
			}
		}

		var name = this.state.store.name
        var details = this.state.store.details;

        if(i18n.locale != this.state.store.defaultLanguage){
            name    = this.state.store.nameSec
            details = this.state.store.detailsSec
        }

        if(name == undefined || name == "")
            name = this.state.store.name
        if(details == undefined || details == "")
			details = this.state.store.details

		var branchName = ""
		if(this.state.deliveryData != undefined && this.state.deliveryData.branch != undefined)
		{
			branchName = this.state.deliveryData.branch.name
			if(i18n.locale != this.state.store.defaultLanguage){
				branchName    = this.state.deliveryData.branch.nameSecondary
			}		
		}

		var icoName = "ios-arrow-forward"
		if(RNI18nManager.isRTL)
			icoName = "ios-arrow-back"				 
			
		var h = ""
		var m = ""
		var s = ""
		if(this.state.offerData != undefined)
		{
			var startDate = new Date().getTime()
			var endDate  = this.state.offerData.endDate
			var d = ((endDate - startDate)/1000).toFixed(0)
			d = Number(d);
			
			h = Math.floor(d / 3600).toString();
			m = Math.floor(d % 3600 / 60).toString();
			s = Math.floor(d % 3600 % 60).toString();	
			
			if(h.length == 1)
				h = "0" + h
			if(m.length == 1)
				m = "0" + m
			if(s.length == 1)
				s = "0" + m
		}

		return (
			<View style={{flex:1}} onLayout={event => {
				const layout = event.nativeEvent.layout;
				this.state.headerHeight = layout.height
			  }}>
				
				{!this.state.showFullMode && (
					
					<View style={{height: 365}}>
						<ImageBackground source={that.state.store.bgImageUrl} style={{height: 255, overflow:"visible"}}/>

						<View style={{marginTop: 18, height: 100, marginLeft: 15, flexDirection: "row"}}>				
							
							<View style={{width: 90, height: 80}}>
								
							{ that.state.stories != undefined && that.state.stories.length > 0 && (
								<HoverableOpacity style={{width: 80, height: 80, justifyContent: "center", alignItems: "center", alignItems: "center"}}
									onPress={() => { this.openStory() }}
								>
									<StoryWrapper>
										<img src={that.state.store.logoUrl} />
										<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">  
											<circle cx="50" cy="50" r="40" />
										</svg>
									</StoryWrapper>

								</HoverableOpacity>
								)}	

								{ that.state.stories == undefined || that.state.stories.length == 0 && (
								<View style={{width: 80, height: 80, justifyContent: "center", alignItems: "center", alignItems: "center"}}
									>
										<Image source={that.state.store.logoUrl} style={{width: 90, height: 90, borderRadius: 45, overflow:"hidden"}}/>
								</View>
								)}	

							</View>
													
							
							<View style={{marginLeft: 10, marginRight:10, height: 80, justifyContent: "center"}}>				
								<Text style={{textAlign:"left", fontFamily: "main-bold", color:'black', fontSize:20}}>{name}</Text>			
								<Text style={{textAlign:"left", fontFamily: 'main-regular',color:'black', fontSize:15, fontWeight:'normal'}}>{details}</Text>	
							</View>
						</View>
					</View>
				)}

				{that.state.stories.length > 0 && this.state.showFullMode && (
					<View style={{height: 100, marginTop: 5}}>					
						<FlatList
							horizontal={true}
							extraData={this.state}
							data={this.state.stories}
							renderItem={this.renderStoryItem}
							keyExtractor={item => item.key}
						/>					
					</View>
				)}

				{(that.state.deliveryData.area == undefined || that.state.deliveryData.area == "") && that.state.deliveryData.branch == undefined && ( 

					<View style={{height: 40, marginTop: 15, marginLeft: 15, marginRight: 15, justifyContent: "center", alignContent: "center", borderBottomWidth: 1, borderBottomColor: color.menuUnselected, flexDirection: "row"}}>				
							{(that.state.store.enableDelivery || that.state.store.enableCustomDelivery) && (
								<TouchableOpacity  style={{flexDirection: "row", justifyContent: "center", marginTop: 5}}
									onPress={() => { that.openArea() }}
									>
										<Text style={{fontFamily: 'main-regular',fontSize:14, color: this.state.store.primaryColor, marginRight: 15, marginTop: 5, textAlign: "center", marginLeft: "auto", justifyContent: "center"}}>{i18n.t("delivery")}</Text>										
								</TouchableOpacity>
							)}
							{that.state.store.enablePickup && (
							<TouchableOpacity style={{flexDirection: "row", marginLeft: "auto", justifyContent: "center"}}
												onPress={() => { that.openBranch() }}
										>
										<Text style={{fontFamily: 'main-regular',fontSize:14, color: this.state.store.primaryColor, marginRight: 15, marginTop: 5, textAlign: "center", marginLeft: "auto", justifyContent: "center"}}>{i18n.t("pickup")}</Text>										
							</TouchableOpacity>
							)}

					</View>
				)}
				
				{that.state.deliveryData.area != undefined && that.state.deliveryData.area.name != undefined && ( 
					<View style={{flex: 1, marginTop: 5}}>

						<View style={{height: 40, marginTop: 15, marginLeft: 15, marginRight: 15, justifyContent: "center", alignContent: "center", borderBottomWidth: 1, borderBottomColor: color.menuUnselected, flexDirection: "row"}}>				
							<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:16, textAlign: "center", marginTop: 5}}>{i18n.t("delivery")}</Text>	
							{that.state.store.enablePickup && (
							<TouchableOpacity style={{flexDirection: "row", marginLeft: "auto", justifyContent: "center"}}
												onPress={() => { that.openBranch() }}
										>
										<Text style={{fontFamily: 'main-regular',fontSize:14, color: this.state.store.primaryColor, marginRight: 15, marginTop: 5, textAlign: "center", marginLeft: "auto", justifyContent: "center"}}>{i18n.t("pickup")}</Text>										
							</TouchableOpacity>
							)}

						</View>

						<TouchableOpacity style={{marginLeft: 15, marginRight: 15, height:55, justifyContent: "center", alignContent: "center"}}
												onPress={() => { that.openArea() }}
										>
							<View style={{flexDirection: "row", justifyContent: "center"}}>
								<Text style={{fontFamily: 'main-regular', color: color.detailsColor, fontSize:14, textAlign: "center", marginTop: 5}}>{i18n.t("area")}</Text>	
								<View style={{flexDirection: "row", marginLeft: "auto", justifyContent: "center"}}>
									{i18n.locale == "ar" &&(
									<Text style={{fontFamily: 'main-regular',fontSize:14, color: this.state.store.primaryColor, marginRight: 15, marginTop: 5, textAlign: "center"}}>{that.state.deliveryData.area.nameArabic} </Text>		)}
									{i18n.locale != "ar" &&(
									<Text style={{fontFamily: 'main-regular',fontSize:14, color: this.state.store.primaryColor, marginRight: 15, marginTop: 5, textAlign: "center"}}>{that.state.deliveryData.area.name} </Text>		)}
									<Ionicons name={icoName} size={24} color={this.state.store.primaryColor} />	
								</View>														
							</View>
						</TouchableOpacity>

						<TouchableOpacity style={{marginLeft: 15, marginRight: 15, height:55, justifyContent: "center"}}
												onPress={() => { this.openScheduleTimings() }}
										>
							<View style={{flexDirection: "row", justifyContent: "center"}}>
								<Text style={{ fontFamily: 'main-regular',color: color.detailsColor, fontSize:14, textAlign: "center", marginTop: 5}}>{i18n.t("scheduledTime")}</Text>	
								<View style={{flexDirection: "row", marginLeft: "auto",justifyContent: "center"}}>
									<Text style={{ fontFamily: 'main-regular',fontSize:14, color: this.state.store.primaryColor, marginRight: 15, marginTop: 5, textAlign: "center"}}>{timings}</Text>
									<Ionicons name={icoName} size={24} color={this.state.store.primaryColor} />	
								</View>														
							</View>
						</TouchableOpacity>

					</View>
				)}

				{that.state.deliveryData.branch != undefined && ( 
					<View style={{flex: 1, marginTop: 5}}>

						<View style={{height: 40, marginTop: 15, marginLeft: 15, marginRight: 15, justifyContent: "center", alignContent: "center", borderBottomWidth: 1, borderBottomColor: color.menuUnselected, flexDirection: "row"}}>				
							
							<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:16, textAlign: "center", marginTop: 5}}>{i18n.t("pickup")}</Text>	
							{(that.state.store.enableDelivery || that.state.store.enableCustomDelivery) && (
							<TouchableOpacity style={{flexDirection: "row", marginLeft: "auto", justifyContent: "center"}}
												onPress={() => { that.changeToDelivery() }}
										>
										<Text style={{fontFamily: 'main-regular',fontSize:14, color: this.state.store.primaryColor, marginRight: 15, marginTop: 5, textAlign: "center", marginLeft: "auto", justifyContent: "center"}}>{i18n.t("delivery")}</Text>										
							</TouchableOpacity>
							)}
						</View>

						<TouchableOpacity style={{marginLeft: 15, marginRight: 15, height:55, justifyContent: "center", alignContent: "center"}}
												onPress={() => { that.openBranch() }}
										>
							<View style={{flexDirection: "row", justifyContent: "center"}}>
								<Text style={{fontFamily: 'main-regular', color: color.detailsColor, fontSize:14, textAlign: "center", marginTop: 5}}>{i18n.t("branch")}</Text>	
								<View style={{flexDirection: "row", marginLeft: "auto", justifyContent: "center"}}>
									<Text style={{fontFamily: 'main-regular',fontSize:14, color: this.state.store.primaryColor, marginRight: 15, marginTop: 5, textAlign: "center"}}>{branchName} </Text>		
									<Ionicons name={icoName} size={24} color={this.state.store.primaryColor} />	
								</View>														
							</View>
						</TouchableOpacity>

					</View>
				)}

				<TouchableOpacity style={{marginLeft: 15, marginRight: 15, height:36, marginTop: 5,						
						justifyContent: "center", alignContent: "center", marginBottom: 10}}
											onPress={() => { that.switchToSearch() }}
				>
					<View style={{backgroundColor: '#F5F5F5', flex:1, borderRadius: 8, justifyContent:"center"}}>
						<Text style={{textAlign:'left', marginLeft: 10, marginRight:10, color: color.detailsColor, fontFamily: 'main-regular'}}>{i18n.t("search")}</Text>					
					</View>

				</TouchableOpacity>

				{ this.state.promoData != undefined &&(
					<View style={{backgroundColor: color.bigSeparator, height: this.state.showPromoError ? 180 : 165}}> 
						
						<View style={{backgroundColor: 'white', borderRadius: 8, marginTop: 10, marginLeft: 10, marginRight: 10, height: 145 }}>	
							
								<div style={{margin: 10, width: 49, height: 60}}>
									<svg xmlns="http://www.w3.org/2000/svg" width="49" height="60" viewBox="0 0 110 135">										
										<g id="PromoCode">
											<g id="discount" transform="translate(-47.857 4.109)">
											<g id="Group_28" data-name="Group 28" transform="translate(54.857)">
												<g id="Group_27" data-name="Group 27">
												<path id="Path_103" data-name="Path 103" d="M138.567,0H66.647a11.79,11.79,0,0,0-11.79,11.79V120.26a4.716,4.716,0,0,0,2.8,4.274,4.863,4.863,0,0,0,5.011-.884l9.874-9.137,12.085,10.759a4.458,4.458,0,0,0,6.042,0l11.937-10.759,11.937,10.759a4.716,4.716,0,0,0,6.042,0l12.085-10.759,9.874,9.137a4.863,4.863,0,0,0,5.011.884,4.716,4.716,0,0,0,2.8-4.274V11.79A11.79,11.79,0,0,0,138.567,0Zm5.9,117.312-8.7-7.958a4.569,4.569,0,0,0-6.19,0L117.64,120.113,105.7,109.354a4.651,4.651,0,0,0-6.19,0L87.575,120.113,75.638,109.354a4.569,4.569,0,0,0-6.19,0l-8.7,7.958V11.79a5.9,5.9,0,0,1,5.9-5.9h71.92a5.9,5.9,0,0,1,5.9,5.9V117.312Z" transform="translate(-54.857)" fill="#a4a4a4"/>
												<path id="Path_104" data-name="Path 104" d="M122.066,244.132H149.33a2.948,2.948,0,0,0,0-5.9H122.066a2.948,2.948,0,1,0,0,5.9Z" transform="translate(-100.991 -171.033)" fill="#a4a4a4"/>
												<path id="Path_105" data-name="Path 105" d="M175.416,284.212H122.066a2.948,2.948,0,1,0,0,5.9h53.351a2.948,2.948,0,1,0,0-5.9Z" transform="translate(-100.991 -204.039)" fill="#a4a4a4"/>
												<path id="Path_106" data-name="Path 106" d="M175.416,330.71H122.066a2.948,2.948,0,0,0,0,5.9h53.351a2.948,2.948,0,0,0,0-5.9Z" transform="translate(-100.991 -237.42)" fill="#a4a4a4"/>
												<path id="Path_107" data-name="Path 107" d="M159.817,76.174a9.874,9.874,0,1,0-9.874-9.874A9.874,9.874,0,0,0,159.817,76.174Zm0-13.854a3.979,3.979,0,1,1-3.979,3.979A3.979,3.979,0,0,1,159.817,62.32Z" transform="translate(-123.12 -40.508)" fill={this.state.store.primaryColor}/>
												<path id="Path_108" data-name="Path 108" d="M238.184,134.792a9.874,9.874,0,0,0,0,19.749h0a9.874,9.874,0,0,0,0-19.749Zm0,13.853a3.979,3.979,0,1,1,3.979-3.979A3.979,3.979,0,0,1,238.184,148.645Z" transform="translate(-179.381 -96.769)" fill={this.state.store.primaryColor}/>
												<path id="Path_109" data-name="Path 109" d="M160.3,99.993a2.948,2.948,0,0,0,2.063.884,2.652,2.652,0,0,0,2.063-.884l31.539-31.539a2.948,2.948,0,0,0-4.127-4.127L160.3,95.719A3.1,3.1,0,0,0,160.3,99.993Z" transform="translate(-129.943 -45.758)" fill={this.state.store.primaryColor}/>
												</g>
											</g>
											</g>
										</g>
									</svg>
								</div>

								<View style={{position: "absolute", marginTop: 15, marginLeft: 65}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "left", fontSize: 16}}>{this.state.promoData.title}</Text>																						
									<Text style={{color: 'black', fontFamily:"main-regular", textAlign: "left", fontSize: 14}}>{this.state.promoData.details}</Text>																						
								</View>	

								<TouchableOpacity disabled={this.state.applyPromo}  style={{marginLeft: "auto", marginRight: 10,  marginTop: 15, width: 100, height: 36, borderColor:"#E5E5E9", borderRadius: 18, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
										onPress={() => { 										
											this.applyPromo()
										}}
								>
									<Text style={{ fontFamily: 'main-regular', color: this.state.applyPromo == true ? 'gray' :  this.state.store.primaryColor, 
													fontSize: 12, fontFamily: "main-bold", textAlign: "center"}}>{i18n.t("apply")}</Text>
								</TouchableOpacity>
						</View>

						{ this.state.showPromoError  && (
						<Text style={{ fontFamily: 'main-regular', color: 'red', marginTop: 6, fontSize: 14, textAlign: "center"}}>{i18n.t("invalidPromo")}</Text>
						)}
					</View>
				)}

				{ this.state.offerData != undefined &&(
					<View style={{backgroundColor: color.bigSeparator, height: 200}}> 
						
						<View style={{backgroundColor: 'white', borderRadius: 8, marginTop: 10, marginLeft: 10, marginRight: 10, height: 190, justifyContent: "center", alignItems: "center" }}>	
							
								<div style={{margin: 10, width: 49, height: 49}}>
									<svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 110 135">										
										<g id="PromoCode">
											<g id="discount" transform="translate(-47.857 4.109)">
											<g id="Group_28" data-name="Group 28" transform="translate(54.857)">
												<g id="Group_27" data-name="Group 27">
												<path id="Path_103" data-name="Path 103" d="M138.567,0H66.647a11.79,11.79,0,0,0-11.79,11.79V120.26a4.716,4.716,0,0,0,2.8,4.274,4.863,4.863,0,0,0,5.011-.884l9.874-9.137,12.085,10.759a4.458,4.458,0,0,0,6.042,0l11.937-10.759,11.937,10.759a4.716,4.716,0,0,0,6.042,0l12.085-10.759,9.874,9.137a4.863,4.863,0,0,0,5.011.884,4.716,4.716,0,0,0,2.8-4.274V11.79A11.79,11.79,0,0,0,138.567,0Zm5.9,117.312-8.7-7.958a4.569,4.569,0,0,0-6.19,0L117.64,120.113,105.7,109.354a4.651,4.651,0,0,0-6.19,0L87.575,120.113,75.638,109.354a4.569,4.569,0,0,0-6.19,0l-8.7,7.958V11.79a5.9,5.9,0,0,1,5.9-5.9h71.92a5.9,5.9,0,0,1,5.9,5.9V117.312Z" transform="translate(-54.857)" fill="#a4a4a4"/>
												<path id="Path_104" data-name="Path 104" d="M122.066,244.132H149.33a2.948,2.948,0,0,0,0-5.9H122.066a2.948,2.948,0,1,0,0,5.9Z" transform="translate(-100.991 -171.033)" fill="#a4a4a4"/>
												<path id="Path_105" data-name="Path 105" d="M175.416,284.212H122.066a2.948,2.948,0,1,0,0,5.9h53.351a2.948,2.948,0,1,0,0-5.9Z" transform="translate(-100.991 -204.039)" fill="#a4a4a4"/>
												<path id="Path_106" data-name="Path 106" d="M175.416,330.71H122.066a2.948,2.948,0,0,0,0,5.9h53.351a2.948,2.948,0,0,0,0-5.9Z" transform="translate(-100.991 -237.42)" fill="#a4a4a4"/>
												<path id="Path_107" data-name="Path 107" d="M159.817,76.174a9.874,9.874,0,1,0-9.874-9.874A9.874,9.874,0,0,0,159.817,76.174Zm0-13.854a3.979,3.979,0,1,1-3.979,3.979A3.979,3.979,0,0,1,159.817,62.32Z" transform="translate(-123.12 -40.508)" fill={this.state.store.primaryColor}/>
												<path id="Path_108" data-name="Path 108" d="M238.184,134.792a9.874,9.874,0,0,0,0,19.749h0a9.874,9.874,0,0,0,0-19.749Zm0,13.853a3.979,3.979,0,1,1,3.979-3.979A3.979,3.979,0,0,1,238.184,148.645Z" transform="translate(-179.381 -96.769)" fill={this.state.store.primaryColor}/>
												<path id="Path_109" data-name="Path 109" d="M160.3,99.993a2.948,2.948,0,0,0,2.063.884,2.652,2.652,0,0,0,2.063-.884l31.539-31.539a2.948,2.948,0,0,0-4.127-4.127L160.3,95.719A3.1,3.1,0,0,0,160.3,99.993Z" transform="translate(-129.943 -45.758)" fill={this.state.store.primaryColor}/>
												</g>
											</g>
											</g>
										</g>
									</svg>
								</div>

								<View style={{marginTop: 5, flexDirection: "row"}}>

									<Text style={{ fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{h.length > 1 ? h.charAt(0): 0}</Text>
									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{h.length > 1 ? h.charAt(1): 0}</Text>

									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, textAlign: "center"}}>:</Text>

									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{m.length > 1 ? m.charAt(0): 0}</Text>
									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{m.length > 1 ? m.charAt(1): 0}</Text>

									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, textAlign: "center"}}>:</Text>

									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{s.length > 1 ? s.charAt(0): 0}</Text>
									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{s.length > 1 ? s.charAt(1): 0}</Text>
								</View>

								<TouchableOpacity style={{marginTop: 20, width: "50%", height: 36, borderColor: this.state.store.primaryColor, backgroundColor: this.state.store.primaryColor, borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
										onPress={() => { 																					
											this.context.onUpdate = this.updateCart.bind(this)
											this.props.navigation.navigate("offers");
										}}
								>
									<Text style={{ fontFamily: 'main-regular', color: 'white',
													fontSize: 12, fontFamily: "main-bold", textAlign: "center"}}>{i18n.t("clickOffers")}</Text>
								</TouchableOpacity>
						</View>
					</View>
				)}

				<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>

			</View>
		)
	}	
	
	renderDetails(){

		var opacity = 1
		var shouldDisable = false
		var minOrderValueRequired = this.state.store.minimumOrder
		if(this.state.deliveryData.area != undefined)
		{
			minOrderValueRequired = this.state.deliveryData.area.minOrderPrice
		}
		
		if(this.state.totalPrice < minOrderValueRequired || this.state.totalPrice == 0)
			shouldDisable = true;

		var showOrder = false;
		if(this.state.store.enableDelivery || this.state.store.enableCustomDelivery)
			showOrder = true

		if(this.state.store.enablePickup)
			showOrder = true

		if(this.state.totalPrice == undefined || this.state.totalPrice == "")
			this.state.totalPrice = 0

		var btnText = i18n.t("startOrdering")
		if(this.state.store.todayOrdersCount >= this.state.store.orderLimit)
			this.state.store.status = false

		if(this.state.store.status == false)
		{
			btnText = i18n.t("tempClosed")
			shouldDisable = true
			this.state.showCart = false
		}

		if(shouldDisable)
			opacity = .5

		let item = this.state.categoryData
		var name = ""
		if(item != undefined)
		{
			name 	= item.category.name
			if(i18n.locale != this.state.store.defaultLanguage){
				name    = item.category.nameSecondary
			}

			if(name == undefined || name == "")
				name = item.category.name

			var icoName = "ios-arrow-back"
			if(RNI18nManager.isRTL)
				icoName = "ios-arrow-forward"
		}
		
		return (
			<View style={{flex: 1}}>

				{this.state.categoryData == undefined && this.state.data.length > 0 && this.state.showFullMode && this.state.store.deskType == 0 && (
						<SectionList
							contentOffset={{x: 0, y: 50}}
							scrollEventThrottle={5}
							onScroll={this.handleScroll}
							ListHeaderComponent={this.renderHeader(this)}   
							stickySectionHeadersEnabled
							sections={this.state.data}
							renderItem={this.renderListItem}
							renderSectionHeader={this.renderSectionHeader}
						/>
				)}
				{this.state.categoryData == undefined && this.state.data.length > 0 && this.state.showFullMode && this.state.store.deskType == 1 && (
						<FlatList
							contentOffset={{x: 0, y: 50}}
							scrollEventThrottle={5}
							ListHeaderComponent={this.renderHeader(this)}   
							onScroll={this.handleScroll}
							data={this.state.data}
							renderItem={this.renderGalleryCategory}
							numColumns={2}
						/>
				)}

				{this.state.categoryData == undefined && this.state.data.length > 0 && !this.state.showFullMode && this.state.store.mobType == 0 && (
						<SectionList
							contentOffset={{x: 0, y: 50}}
							scrollEventThrottle={5}
							onScroll={this.handleScroll}
							ListHeaderComponent={this.renderHeader(this)}   
							stickySectionHeadersEnabled
							sections={this.state.data}
							renderItem={this.renderListItem}
							renderSectionHeader={this.renderSectionHeader}
						/>
				)}

				{this.state.categoryData == undefined && this.state.data.length > 0 && !this.state.showFullMode && this.state.store.mobType == 1 && (
						<FlatList
							contentOffset={{x: 0, y: 50}}
							scrollEventThrottle={5}
							ListHeaderComponent={this.renderHeader(this)}   
							onScroll={this.handleScroll}
							data={this.state.data}
							renderItem={this.renderGalleryCategory}
							numColumns={2}
						/>
				)}

				{this.state.categoryData == undefined && this.state.data.length > 0 && !this.state.showFullMode && this.state.store.mobType == 2 && (
						<FlatList
							contentOffset={{x: 0, y: 50}}
							scrollEventThrottle={5}
							ListHeaderComponent={this.renderHeader(this)}   
							onScroll={this.handleScroll}
							data={this.state.data}
							renderItem={this.renderListCategory}
						/>
				)}				

				{this.state.categoryData == undefined && this.state.data.length == 0 && (
					this.state.fakeData.map((e, i) => <PlaceholderComp key={i} />)
				)}

				{this.state.categoryData != undefined && (
						<View style={styles.topBar}>															
							<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{name}</Text>																						
							</View>	
							<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignContent: "center", alignItems: "center"}}
										onPress={() => { this.setState({categoryData: undefined}) }} >
								<Ionicons name={icoName} size={24} color={'black'} />
							</TouchableOpacity>		
						</View>
				)}

				{this.state.categoryData != undefined && (
						<FlatList
								data={item.data}
								renderItem={this.renderGalleryItem}
								numColumns={2}
							/>
				)}

				{this.state.showCart && showOrder && (
					<View style={{height: 64, backgroundColor:"white", justifyContent: "center", marginTop: "auto"}}>											
						<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 8, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.reviewOrder() }}
								>
							<View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
								<View style={{backgroundColor: this.state.store.primaryDarkColor, borderRadius: 3, marginLeft: 10, width: 32, height: 32, alignItems: "center", justifyContent: "center", alignContent: "center"}}>
									<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:13, textAlign: "center"}}>{this.state.orderCount}</Text>
								</View>
								<Text style={{ fontFamily: 'main-regular',position: "absolute", marginLeft: "auto", marginRight: "auto", color:'#FFF', fontWeight:"bold", fontSize:14}}>{i18n.t("reviewOrder")}</Text>
								{ RNI18nManager.isRTL && (
									<Text style={{ fontFamily: 'main-regular',marginLeft: "auto", marginRight: 10, color:'#FFF', fontWeight:"normal", fontSize:13}}>{this.state.totalPrice.toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>		
								)}
								{ !RNI18nManager.isRTL && (
									<Text style={{ fontFamily: 'main-regular',marginLeft: "auto", marginRight: 10, color:'#FFF', fontWeight:"normal", fontSize:13}}>{i18n.t('currency.' + this.state.store.currency.toLowerCase())} {this.state.totalPrice.toFixed(3)}</Text>		
								)}
							</View>
						</TouchableOpacity>
					</View>
				)}	

				{!this.state.showCart && (
					<View style={{height: 64, backgroundColor:"white", justifyContent: "center", marginTop: "auto"}}>											
						<TouchableOpacity disabled={shouldDisable} style={{opacity: opacity, marginLeft: 10, marginRight: 10, marginBottom: 8, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.moveToOrder() }}
								>
							<View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
								<Text style={{ fontFamily: 'main-bold',position: "absolute", marginLeft: "auto", marginRight: "auto", color:'#FFF', fontSize:14}}>{btnText}</Text>
							</View>
						</TouchableOpacity>
					</View>
				)}	
			</View>
		)
	}

	render() {

		var that = this
	
		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>

					{this.state.showFullMode && (										
						
						<View style={styles.webContainer}>						
							
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>
								{this.renderDetails()}						
							</View>	
							<Main {...this.state} changeMenu={this.changeMenu} />
						</View>					
					)}
					
					{!this.state.showFullMode && !this.state.showMenu && this.state.categoryData == undefined &&(
						<View style={styles.container}>						
													
							<View style={{marginTop: 50, backgroundColor: color.backgroundColor, height: this.state.height - 50}}>
								{this.renderDetails()}
							</View>	
							<TopBar {...this.state} changeState={this.changeState} />
						</View>
					)}
					{!this.state.showFullMode && !this.state.showMenu && this.state.categoryData != undefined &&(
						<View style={styles.container}>						
													
							<View style={{marginTop: 0, backgroundColor: color.backgroundColor, height: this.state.height}}>
								{this.renderDetails()}
							</View>	
						</View>
					)}


					{!this.state.showFullMode && this.state.showMenu && (					
						<View style={styles.container}>						

							<Menu {...this.state} changeState={this.changeState} />
							
						</View>
					)}	
					
				</View>
			)}
			</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: color.backgroundColor
	},
	topBar: {
        height: 50,
        flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    },
	webContainer: {
		flex: 1,
		flexDirection: "row",
	}
});
